<template>
  <div class="heroes-side-picks" :class="classes">
    <div class="heroes-side-picks__title">{{ title }}</div>
    <HeroesSidePicksHero
      v-for="n of number"
      :key="n"
      :hero="getHero(picks[n - 1])"
      :left="left"
      :right="right"
    />
  </div>
</template>

<script>
import HeroesSidePicksHero from "./HeroesSidePicksHero";
import { mapState } from "vuex";

export default {
  name: "HeroesSidePicks",
  components: {
    HeroesSidePicksHero
  },
  props: {
    pick: Boolean,
    ban: Boolean,
    left: Boolean,
    right: Boolean,
    number: Number,
    picks: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState("dictionaries", {
      heroes: ({ dictionaries }) => dictionaries.heroes
    }),
    classes() {
      return {
        "heroes-side-picks_left": this.left,
        "heroes-side-picks_right": this.right,
        "heroes-side-picks_horizontal": this.horizontal
      };
    },
    title() {
      return this.pick ? "Пик" : "Баны";
    }
  },
  methods: {
    getHero(pick) {
      return pick && this.heroes.find(hero => hero.id === pick.hero_id);
    }
  }
};
</script>

<style lang="scss">
$p: ".heroes-side-picks";

.heroes-side-picks {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 2px solid transparent;
  padding: 15px 20px 20px;
  position: relative;

  &__title {
    margin-bottom: 15px;
    font-family: "Montserrat";
    font-weight: bold;
    font-size: 20px;
    text-align: center;
  }

  &_left {
    border-color: #e72f31;
  }

  &_right {
    border-color: #2d9cdb;
  }

  @include breakpoint("md-and-down") {
    flex-direction: row;
    padding: 40px 15px 15px;
    justify-content: center;

    #{$p}__title {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      top: 10px;
    }
  }
}
</style>
